import { LiveEvent } from '../../../../core/models/live-events'

export abstract class EventComponent<T extends LiveEvent> {
  event!: T
}
